<template>
  <div class="inner-box">
    <el-form size="mini" :model="form" ref="catInfoForm">
      <el-row>
        <el-col>
          <el-col :span="12">
            <el-form-item label="아이디" v-if="form.userId === '' " required>
              <el-input v-model="form.userCd" ></el-input>
              <el-input v-model="form.userId" v-show="false"></el-input>
            </el-form-item>
            <el-form-item label="아이디" v-else>
              <el-input v-model="form.userCd" readonly ></el-input>
              <el-input v-model="form.userId" v-show="false"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="비밀번호" v-if="form.userId === '' " required>
              <el-input type="password" v-model="form.userPwd"></el-input>
            </el-form-item>
            <el-form-item label="비밀번호" style="width: 20%;" v-else>
              <el-button type="info" icon="fas fa-key" @click="PwdChange" style="width: 100%; display: inline-block;">  비밀번호변경</el-button>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="이름" required>
            <el-input v-model="form.userNm"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-col :span="12">
            <el-form-item label="전화번호">
              <el-input v-model="form.telNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="휴대폰">
              <el-input v-model="form.hpNo"></el-input>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="이메일">
            <el-input v-model="form.email"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-col :span="12">
            <el-form-item label="입사일자" required>
              <el-date-picker type="date" placeholder="Pick a date" v-model="form.enterDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="부서">
              <el-col style="width: 100%; display: inline-block;">
                <el-select v-model="form.parentId">
                  <el-option value=''  label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['ParentDept']"
                      :key="item.value"
                      :value="parseInt(item.key)"
                      :label="item.value">
                  </el-option>
                </el-select>

                <el-select v-model="form.deptId" v-if="form.parentId !='' && combos['Dept'].length > 0">
                  <el-option value=''  label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['Dept']"
                      :key="item.value"
                      :value="parseInt(item.key)"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="재직여부">
            <el-checkbox v-model="form.useYn" true-label="Y" false-label="N" style="width: 100%;"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="CTI사용여부">
            <el-checkbox v-model="form.ctiYn" true-label="Y" false-label="N" style="width: 100%;"/>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item label="보안그룹" required>
            <el-select v-model="form.groupUid" style="width: 100%">
              <el-option value=''  label="전체">권한선택</el-option>
              <el-option
                  v-for="item in combos['Group']"
                  :key="item.value"
                  :value="parseInt(item.key)"
                  :label="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="내선번호">
            <el-input v-model="form.ctiStation"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-col :span="12">
            <el-form-item label="CTI아이디">
              <el-input v-model="form.ctiId"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="CTI비밀번호">
              <el-input v-model="form.ctiPwd"></el-input>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>


      <el-row>
        <el-col>
          <el-form-item label="메모">
            <el-input
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 6}"
                placeholder="메모를 작성하세요."
                v-model="form.description">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="16">
          <el-form-item label="사진">
            <el-image :src="form.pictureUrl" fit="scale-down" :preview-src-list="[form.pictureUrl]" style="width: 80px; height: 85px" lazy>
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="사진첨부">
            <input type="file" accept="image/*" ref="file" hidden @change="fileChangeEvent"/>
            <el-button type="primary" @click="fileOnClick">파일첨부</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-form size="mini" :model="form" ref="catInfoForm">
      <el-row>
        <el-col>
          <el-col :span="12">
            <el-form-item label="대행사여부">
              <el-checkbox v-model="form.agYn" true-label="Y" false-label="N" style="width: 100%;"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="대행사소속 제조사" style="width: 50%;">
              <el-input v-model="form.agMakerNm" readonly></el-input>
              <el-input v-model="form.agMaker" v-show="false"></el-input>
            </el-form-item>
            <el-form-item label="" style="width: 40%;">
              <el-button type="info" icon="fas" @click="openModel" style="width: 100%; display: inline-block;">  대행사소속 제조사</el-button>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>
    </el-form>

  </div>
</template>

<script>
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import _ from "lodash";
import PwdChange from "@/components/PwdChange.vue";
import MakerModal from "@/components/InfoManage/UserInfo/MakerModal";

export default {
  name: "userInfo",
  components: {ButtonCellRenderer, MakerModal},
  props: ['userDetail'],
  data() {
    return {
      form: {
        addr1: "",
        addr2: "",
        asAgentId:"",
        asAgentNm: "",
        companyId: "",
        createDt: "",
        creatorId: "",
        ctiId: "",
        ctiPwd: "",
        ctiStation: "",
        ctiYn: "",
        deleteYn: "",
        deptId: "",
        description: "",
        dutyId: "",
        email: "",
        emailYn: "",
        enterDt: "",
        erpId: "",
        erpPwd: "",
        faxNo: "",
        groupUid: "",
        hpNo: "",
        juminNo: "",
        loginYn: "",
        pictureUrl: "",
        retireDt: "",
        telNo: "",
        updateDt: "",
        updatorId: "",
        useYn: "",
        userCd: "",
        userId: "",
        userNm: "",
        userPwd:"",
        zipCd: "",
        parentId: "",
        chk1: false,
        chk2: false,
        agYn: "N",
        agMaker: "",
        agMakerNm: ""
      },
      makerData: [],
      combos: {
        'Dept': [], //제조사
        'ParentDept': [],
        'Group' : []
      },
    };
  },
  methods: {
    setuserInfo() {

      // this.form = Object.assign(this.form, this.userDetail);

      if (this.isEmpty(this.userDetail) !== "") this.form = this.userDetail;

      if(this.form.deptId == 0) this.form.deptId = "";

      this.makerData.forEach(x=>{
        if(this.form.agMaker == x.makerId) this.form.agMakerNm = x.makerNm;
      })
    },
    btnImageUpload_Click() {
      //Alert(hddVirtualPath.Value);
      //this.form.pictureUrl = GetThumbnail(ResolveUrl(hddVirtualPath.Value), "80x85");
      //txtPICTURE_URL.Value = hddVirtualPath.Value;
    },
    GetThumbnail(url, thumbnailSuffix){
      return (url, thumbnailSuffix, "System.Image.Default");
    },
    fileOnClick() {
      this.$refs.file.click();
      //console.log(this.$refs.file.files[0]);

    },
    fileChangeEvent() {
      console.log("fileChangeEvent")
      this.file = this.$refs.file.files[0] || {
        name: undefined
      }

      this.fileLoaded = this.$refs.file.files[0] !== undefined

      this.uploadProfile(this.file);
    },
    uploadProfile(file) {
      let form = new FormData();
      form.append('file', file);
      const {companyId, userId} = this.form;
      
      this.$store.commit('loading');
      this.$http.post(`/api/userMng/user/profile/upload/${companyId}/${userId}`, form, {timeout: 60000*60},{
          headers: {
              'Content-Type': 'multipart/form-data'
          }
      }).then(res => {
        this.$swal({
          type: 'success',
          text: `${res.data}`
        });
      }).finally( () => {
        //reload api call
        this.$http.post(`/api/userMng/user/info`, {
          companyId, userId, processTime: ''
        }).then(res => {
          const {pictureUrl} = res.data[0];
          this.$parent.userDetail.pictureUrl = pictureUrl;
        })
        this.$store.commit('finish');
      })
    },
    openModel() {
      let vm = this;
      this.$modal.open({
        width: 400,
        component: MakerModal,
        parent: this,
        props: {
          data: {
            modelNm : vm.form.modelNm
          }
        },
        events: {
          close(param) {
            vm.form.agMaker = param.data.makerId;
            vm.form.agMakerNm = param.data.makerNm;
            vm.$forceUpdate();
          },
        }
      });
    },
    isEmpty(value){
      if( value == "" || value == null || value == undefined || ( value != null && typeof value == "object" && !Object.keys(value).length ) ){
        return ""
      }else{
        return value
      }
    },
    PwdChange(){

      let vm = this

      this.$modal.open({component: PwdChange, parent: this, width: 800, props: {before:'before',after:'after',userId:this.form.userId}})

    },
    async init() {
      this.$store.commit('loading');
      let [query, form] = await Promise.all([
        this.$http.post(`/api/deptMng/service/init`,{
          parentId: this.form.parentId
        })
      ]).finally(() => {
        this.$store.commit('finish');
      });

      this.combos['ParentDept'] = query.data.parentDept;
      if(query.data.dept != null){
        this.combos['Dept'] = query.data.dept;
      }
    },
  },
  mounted() {
    this.init();

    if(this.form.deptId != null){
      this.form.parentId = 24;
    }


    this.$http.post(`/api/group/groupMng/init`,{
      companyId: this.$store.state.loginInfo.compCd
    }).then(response => {
      this.combos['Group'] = response.data.group;
    });

    const vform = {
      companyId: this.$store.state.loginInfo.compCd || '',
      catNm : '',
      processTime: ''
    }
    // console.log('add goOpen start', vform)
    this.$http.post(("/api/obstacleTreatMng/popup/maker"), vform
    ).then(response => {
      if(response.data){
        this.makerData = response.data || []
      }
    }).finally(() => {
      this.$store.commit('finish')

    });


    console.log(this.form);

  },
  chkval(){
    this.form.useYn == 'Y' ? this.form.chk1 = true : this.form.chk1 = false;
    this.form.ctiYn == 'Y' ? this.form.chk2 = true : this.form.chk2 = false;
  },
  watch: {
    userDetail() {
      this.setuserInfo();
    },
    'form.parentId'(){
      this.init();
    },
    'form.deptId'(){
      if(this.form.deptId != ''){
        this.form.parentId = 24;
      }
    }
  }
}

</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 0;
  // &:last-child {
  //   margin-bottom: 0;
  // }
}
.el-form {
  border: 1px solid #c7c7c7;
  padding: 10px 0 0 10px;
  border-radius: 5px;
}
.el-form-item {
  margin-right: 10px;
  // &:last-child {
  //   margin-right: 0;
  // }
}
.large-textarea{
  padding: 0 24px !important
}

</style>